import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import superagent from 'superagent';
import './SignUpVerify.scss';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function SignupVerify({ lang }) {
  const query = useQuery();
  const intl = useIntl();
  const uid = query.get('uid') || 'None';
  const [verifyCloud, setVerifyCloud] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const lang = intl.locale;
      setIsLoading(true);
      try {
        await superagent
          .post('/++api++/@verify-trial-cloud')
          .set('accept', 'application/json')
          .send({ uid, lang });

        setVerifyCloud(true);
      } catch (error) {
        setVerifyCloud(false);
      }
      setIsLoading(false);
    };
    fetchData();
  }, [lang, uid, intl]);

  return (
    <div className="signupupverify wrapper">
      {isLoading ? (
        <div>Loading ...</div>
      ) : (
        <div className="container">
          {verifyCloud ? (
            <>
              <h1>
                <FormattedMessage
                  id="signupverify_title"
                  defaultMessage="Verification successful"
                />
              </h1>
              <p>
                <FormattedMessage
                  id="signupverify_text"
                  defaultMessage="Your cloud is now being created. You will receive an email with your login data shortly."
                />
              </p>
            </>
          ) : (
            <>
              <h1>
                <FormattedMessage
                  id="signupverifyfailed_title"
                  defaultMessage="Verification failed"
                />
              </h1>
              <p>
                <FormattedMessage
                  id="signupverifyfailed_text"
                  defaultMessage="Your verification link is invalid or expired. Please try again."
                />
              </p>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default SignupVerify;
